import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;


import AttendanceTable from "./EmployeeAttendanceTable";

const EmployeeData = () => {

  return (
    <>

      <AttendanceTable/>
    </>
  );
};

export default EmployeeData;
